/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import { SetWmsInnModelCheckbox } from "../sliceWmsInvoiceTag";
import { DBKernObj, fKeyTabInput } from "../../../Utility/Utilitys";

import GCToggleTableSearch from "../../../Component/Common/ReuseableComponent/GCToggleTableSearch";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
   
  CmpCheckboxField,
  CmpTypographyField,
  CmpButtonKWithIcon,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  CmpInputFieldGroupV1,
  CmpSelectArrFieldV1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";

export default function GCContent({
  sTransItemStockObj,
  xTransItemStockShow,

  fGrossAmt,
  bufferObj,
  fonClickInputFocus,
  fonClickInputBlur,
  fOpenContentItemSearchModalKey,
  // fOnChangeSelectUnit,
  fonChangeCheckBoxFoc,
  taxDept1,
  taxDept2,
  ItemUnit,
  fonChangeInputQty,
  fonChangeInputItemName,
  fonChangeInputUnit,
  fonChangeInputUnitRateFC,
  fUnitRateFCSave_onKeyUp,
  fonChangeInputLDisc,
  fonChangeInputLDiscAmt,
  fonChangeInputExcise,
  fOnChangeSelectTaxDept,
  fOnChangeSelectTaxDept2,
  fonChangeInputOtherAmtSc,
  fonChangeInputSupervisorAmtSc,
  fOnChangeSelectIncGroup,
  fOnChangeSelectSupervisorSlab,
  fOnChangeSelectOtherSlab,
  SupervisorSlabs,
  OtherSlabs,
  IncentiveGroups,
  xNarrArr,
  sErrorMsgDetail,
  vRdxWmsInvoiceHead,
  xItemStock,
  xcolumnsDropdownSearch,
  xrowDropdownSearch,
  xOnCellKeyDown,
  xOnRowClick,
  xToggleDropdown,
  xhandleClick,
  xMediaQuery,
  fFocusShowSalesHistoryGrid,
  xinputRef,
  xData,
  xOnChange,
  xDropdownObj,
  xOnKeyUp,

  //narration
  fonChangeInputNarration,
  fNarrationKeyEnter,
  xNarrationToggleDropdown,
  xrowDropdownNarrationSearch,
  xcolumnsDropdownNarrationSearch,
  xOnCellKeyNarrationDown,
  xOnRowNarrationClick,
}) {
  const dispatch = useDispatch();
  const vRdxCheckbox = useSelector(
    (state) => state.sliceWmsInvoiceTag.value.WmsInvoiceCheckbox
  );
  const vModelCheckboxArr = DBKernObj("SONAS_INVOICE")
    ? [
        { name: "SalesOrder", rdxName: vRdxCheckbox.SalesOrder },
        { name: "UnitRateLC", rdxName: vRdxCheckbox.UnitRateLC },
        { name: "LDisc", rdxName: vRdxCheckbox.LDisc },
        { name: "TDisc", rdxName: vRdxCheckbox.TDisc },
        { name: "Foc", rdxName: vRdxCheckbox.Foc },
        { name: "Excise", rdxName: vRdxCheckbox.Excise },
        { name: "TaxAmt", rdxName: vRdxCheckbox.TaxAmt },
        { name: "TaxDept1", rdxName: vRdxCheckbox.TaxDept1 },
        { name: "TaxDept2", rdxName: vRdxCheckbox.TaxDept2 },
        { name: "AddCess", rdxName: vRdxCheckbox.AddCess },
        { name: "Narration", rdxName: vRdxCheckbox.Narration },
        { name: "Incentive", rdxName: vRdxCheckbox.Incentive },
      ]
    : [
        { name: "SalesOrder", rdxName: vRdxCheckbox.SalesOrder },
        { name: "UnitRateLC", rdxName: vRdxCheckbox.UnitRateLC },
        { name: "LDisc", rdxName: vRdxCheckbox.LDisc },
        { name: "TDisc", rdxName: vRdxCheckbox.TDisc },
        { name: "Foc", rdxName: vRdxCheckbox.Foc },
        { name: "Excise", rdxName: vRdxCheckbox.Excise },
        { name: "TaxAmt", rdxName: vRdxCheckbox.TaxAmt },
        { name: "TaxDept1", rdxName: vRdxCheckbox.TaxDept1 },
        { name: "TaxDept2", rdxName: vRdxCheckbox.TaxDept2 },
        { name: "AddCess", rdxName: vRdxCheckbox.AddCess },
        { name: "Narration", rdxName: vRdxCheckbox.Narration },
      ];
  const [sIsChecked, setIsChecked] = useState(false); //ALL CHECKED
  const [sWmsInnCheckbox, setWmsInnCheckbox] = useState(vRdxCheckbox);

  const [sOpenContentModal, setOpenContentModal] = useState(false);
  const [sOpenModalName, setOpenModalName] = useState(""); // MODAL OPEN

  const fModalContentOpen = (e, ModalName) => {
    setOpenModalName(ModalName);
    setOpenContentModal(true);
  };

  const fModalContentClose = () => {
    setOpenContentModal(false);
  };

  const fIsAllChecked = (e) => {
    const iSCheck = e.target.checked;
    setIsChecked(iSCheck);
    setWmsInnCheckbox({
      SalesOrder: iSCheck,
      UnitRateLC: iSCheck,
      LDisc: iSCheck,
      TDisc: iSCheck,
      Foc: iSCheck,
      Excise: iSCheck,
      TaxAmt: iSCheck,
      TaxDept1: iSCheck,
      TaxDept2: iSCheck,
      AddCess: iSCheck,
      Narration: iSCheck,
      Incentive: iSCheck,
    });
  };

  const fSetCheckBox = (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    setWmsInnCheckbox((obj) => ({ ...obj, [nameValue]: iSCheck }));
  };

  useEffect(() => {
    dispatch(SetWmsInnModelCheckbox(sWmsInnCheckbox));
    const vIsAllTrue = Object.values(sWmsInnCheckbox).every(
      (value) => value === true
    );
    setIsChecked(vIsAllTrue);
  }, [sWmsInnCheckbox]);

  return (
    <form
      className="Wms-sales-invoice-Content "
      id="WmssalesinvoiceContentID"
      autoComplete="off"
    >
      <Grid container spacing={0.9} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
          textAlign={"end"}
          justifyContent={"end"}
        >
          <Grid item xs={12} sm={12} md={3} className="hand-pointer">
            <div className="d-flex justify-content-between">
              <span>
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Unit Rate FC"}
                />
              </span>
              <span
                className={
                  vRdxWmsInvoiceHead.A_DocStat == "ENTER"
                    ? "txt-overflow-wms"
                    : "hide-content"
                }
                title={xItemStock?.msp}
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"MSP: " + xItemStock?.msp}
                />{" "}
              </span>
            </div>
          </Grid>
          <Grid item xs={9} sm={11} md={6}>
            {xMediaQuery ? (
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className={
                  vRdxWmsInvoiceHead.A_DocStat !== "ENTER"
                    ? "hide-all-time"
                    : "d-flex justify-content-between align-items-center"
                }
              >
                <Grid item xs={4}>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"Stock=" + sTransItemStockObj.RPStock}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  className={
                    // xTransItemStockShow >= 0
                    xTransItemStockShow ? "" : "hide-all-time"
                  }
                >
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={" CostPr=" + sTransItemStockObj.CostPr}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  className={
                    // xTransItemStockShow >= 0
                    xTransItemStockShow ? "" : "hide-all-time"
                  }
                >
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"LPRate=" + sTransItemStockObj.LPRate}
                  />
                </Grid>
               
              </Grid>
            ) : (
              <div className={"d-flex justify-content-between"}>
               

                <span
                  className={
                    vRdxWmsInvoiceHead.A_DocStat !== "ENTER"
                      ? "hide-all-time"
                      : "d-flex justify-content-between align-items-center"
                  }
                >
                  {" "}
                  &nbsp; &nbsp;
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"Stock=" + sTransItemStockObj.RPStock}
                  />{" "}
                  &nbsp; &nbsp;
                  {Number(sTransItemStockObj.MSP) > 0 ? (
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"MSP=" + sTransItemStockObj.MSP}
                    />
                  ) : (
                    <></>
                  )}
                  &nbsp; &nbsp;
                  {xTransItemStockShow ? (
                    <>
                      <CmpTypographyField
                        xcomponent={"span"}
                        xText={" CostPr=" + sTransItemStockObj.CostPr}
                      />
                      &nbsp;&nbsp;
                      <CmpTypographyField
                        xcomponent={"span"}
                        xText={"LPRate=" + sTransItemStockObj.LPRate}
                      />{" "}
                    </>
                  ) : (
                    <></>
                  )}
                  &nbsp; &nbsp;
                  {/* <CmpTypographyField
                xcomponent={"span"}
                xText={"VALUE: " + xItemStock?.costpr}
              />
              &nbsp; &nbsp; */}
                </span>
              </div>
            )}
          </Grid>
          {!xMediaQuery && (    <Grid item xs={3} sm={1} md={3}>
            <MoreHorizOutlinedIcon
              onClick={(e) => {
                fModalContentOpen(e, "checkboxModal");
              }}
              className="form-label gnr-title-txt"
            />
          </Grid>)}
        </Grid>

        
        <Grid
          item
          xs={4}
          sm={3}
          md={2}
           
          className={
            vRdxCheckbox.SalesOrder ? "lastkeyDetect " : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="Sales Order"
            xValue={""}
            xType={"text"} // text/number/password
            xName={""}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={8}
          sm={9}
          md={3} 
          className={
            vRdxCheckbox.SalesOrder ? "lastkeyDetect " : "hide-content"
          }
        >
          <GCToggleSearchV1
            xLabelText="Sales Order Name"
            xName={""}
            xType={"text"}
            xValue={""}
            xReadOnly={false}
            xOnChange={""}
            xOnKeyUp={""}
            xError={false}
            xErrorMessage={""}
            xMediaQuery={xMediaQuery}
            xonClickbtn={""}
            xrows={[]}
            xcolumns={[]} //head
            xRowCellClick={""}
            xRowClick={""}
            xToggle={""}
            xData={[]}
            xOnChangeDropdownInput={""}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={""}
          />
        </Grid>
        <Grid item xs={12} sm={2} md={2}   className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Item Code"
            xValue={bufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_Itmcd}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={10}
          // md={"auto"}
          // lg={"auto"}
          md={xToggleDropdown ?7.5:4}
          // lg={5}
          className="lastkeyDetect dropDowntoggle"
        >
          <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"101"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={bufferObj?.B_ItmName}
            xReadOnly={false}
            xOnChange={fonChangeInputItemName}
            xOnKeyUp={(e) => {
              fOpenContentItemSearchModalKey(e, "itemSearch");
            }}
            xError={sErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xhandleClick}
            xrows={xrowDropdownSearch}
            xcolumns={xcolumnsDropdownSearch} //head
            xRowCellClick={xOnCellKeyDown}
            xRowClick={xOnRowClick}
            xToggle={xToggleDropdown}
            xData={xData}
            xOnChangeDropdownInput={xOnChange}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUp}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1}   className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Qty"
            xtabIndex={"102"}
            xValue={bufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fonChangeInputQty}
            xError={sErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_Qty}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_URateFc");
            }}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1.5} className="lastkeyDetect">
          <CmpSelectFieldV1
            xtabIndex={"103"}
            xLabelText="Unit"
            xValue={bufferObj.B_Unit}
            xOnChange={(e) => {
              fonChangeInputUnit(e, ItemUnit);
            }}
            xName={"B_Unit"}
            xData={ItemUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_Unit}
            xDisable={false}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
          />
        </Grid>
        <Grid item xs={4} sm={1} md={1}   className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="BaseQty"
            xValue={bufferObj.B_BaseQty}
            xType={"text"} // text/number/password
            xName={"B_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_BaseQty == "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_BaseQty}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={1}  className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Unit Rate FC"
            xtabIndex={"104"}
            xValue={bufferObj.B_URateFc}
            xType={"number"} // text/number/password
            xName={"B_URateFc"}
            xReadOnly={false}
            xOnChange={fonChangeInputUnitRateFC}
            xError={sErrorMsgDetail.B_URateFc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_URateFc}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => fUnitRateFCSave_onKeyUp(e)}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={
            vRdxCheckbox.UnitRateLC ? "lastkeyDetect " : "hide-content"
          }
        >
         <CmpTextFieldV1
            xLabelText="Unit Rate LC"
            xValue={bufferObj.B_URateLc}
            xType={"text"} // text/number/password
            xName={"B_URateLc"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_URateLc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_URateLc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1}   className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Gross Amt"
            xtabIndex={"105"}
            xValue={bufferObj.B_GrossAmt}
            xType={"text"} // text/number/password
            xName={"B_GrossAmt"}
            xReadOnly={false}
            xOnChange={fGrossAmt}
            xError={sErrorMsgDetail.B_GrossAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_GrossAmt}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.LDisc ? "lastkeyDetect " : "hide-content"}
        >
             <CmpTextFieldV1
            xLabelText="L.Disc %"
            xtabIndex={"106"}
            xValue={bufferObj.B_LDiscPerc}
            xType={"number"} // text/number/password
            xName={"B_LDiscPerc"}
            xReadOnly={false}
            xOnChange={fonChangeInputLDisc}
            xError={sErrorMsgDetail.B_LDiscPerc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_LDiscPerc}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_LDiscAmt");
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.LDisc ? "lastkeyDetect " : "hide-content"}
        >
         <CmpTextFieldV1
            xLabelText="L.Disc Amt"
            xValue={bufferObj.B_LDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_LDiscAmt"}
            xReadOnly={false}
            xOnChange={fonChangeInputLDiscAmt}
            xError={sErrorMsgDetail.B_LDiscAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_LDiscAmt}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_ExciseTaxAmt");
            }}
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.TDisc ? "lastkeyDetect " : "hide-content"}
        >
           <CmpTextFieldV1
            xLabelText="T.Disc %"
            xValue={bufferObj.B_TDiscPerc}
            xType={"text"} // text/number/password
            xName={"B_TDiscPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_TDiscPerc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_TDiscPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.TDisc ? "lastkeyDetect " : "hide-content"}
        >
           <CmpTextFieldV1
            xLabelText="T.Disc Amt"
            xValue={bufferObj.B_TDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_TDiscAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_TDiscAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_TDiscAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={
            vRdxCheckbox.Foc ? "lastkeyDetect text-center" : "hide-content"
          }
        >
         <CmpCheckboxField
            xtabIndex={"107"}
            xChecked={bufferObj?.B_FocFlag === "Y"}
            xOnChange={(e) => {
              fonChangeCheckBoxFoc(e);
            }}
            xDisabled={false}
            xName={"B_FocFlag"}
            xNameField={"FOC"}
            xError={sErrorMsgDetail.B_FocFlag === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_FocFlag}
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.Foc ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="FOC Amount"
            xValue={bufferObj.B_FocAmt}
            xType={"text"} // text/number/password
            xName={"B_FocAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_FocAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_FocAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
         <CmpTextFieldV1
            xLabelText="Excise"
            xtabIndex={"108"}
            xValue={bufferObj.B_ExciseTaxAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxAmt"}
            xReadOnly={false}
            xOnChange={(e) => {
              fonChangeInputExcise(e);
            }}
            xError={sErrorMsgDetail.B_ExciseTaxAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_ExciseTaxAmt}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "Narration");
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Net Excise"
            xValue={bufferObj.B_ExciseTaxNetAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxNetAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_ExciseTaxNetAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_ExciseTaxNetAmt}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.TaxAmt ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="TaxableAmt"
            xValue={bufferObj.B_NetAmt}
            xType={"number"} // text/number/password
            xName={"B_NetAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_NetAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_NetAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.TaxDept1 ? "lastkeyDetect" : "hide-content"}
        >
          <CmpSelectFieldV1
            xtabIndex={"109"}
            xLabelText="TaxDept"
            xValue={bufferObj.B_TaxDept}
            xOnChange={(e) => {
              fOnChangeSelectTaxDept(e, taxDept1);
            }}
            xName={"B_TaxDept"}
            xData={taxDept1}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_TaxDept === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_TaxDept}
            xDisable={true}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.TaxDept1 ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Tax %"
            xValue={bufferObj.B_TaxPerc}
            xType={"text"} // text/number/password
            xName={"B_TaxPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_TaxPerc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_TaxPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.TaxDept1 ? "lastkeyDetect" : "hide-content"}
        >
           <CmpTextFieldV1
            xLabelText="Tax Amt"
            xValue={bufferObj.B_TaxAmt}
            xType={"text"} // text/number/password
            xName={"B_TaxAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_TaxAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_TaxAmt}
            // xOnKeyUp={(e) => {
            //   xFocusInput("B_TaxPerc2");
            // }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.TaxDept2 ? "lastkeyDetect" : "hide-content"}
        >
          <CmpSelectFieldV1
            xtabIndex={"110"}
            xLabelText="TaxDept2"
            xValue={bufferObj.B_TaxDept2}
            xOnChange={(e) => {
              fOnChangeSelectTaxDept2(e, taxDept2);
            }}
            xName={"B_TaxDept2"}
            xData={taxDept2}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_TaxDept2 === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_TaxDept2}
            xDisable={false}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.TaxDept2 ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Tax2%"
            xValue={bufferObj.B_TaxPerc2}
            xType={"text"} // text/number/password
            xName={"B_TaxPerc2"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_TaxPerc2 === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_TaxPerc2}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.TaxDept2 ? "lastkeyDetect" : "hide-content"}
        >
         <CmpTextFieldV1
            xLabelText="Tax2Amt"
            xValue={bufferObj.B_TaxAmt2}
            xType={"text"} // text/number/password
            xName={"B_TaxAmt2"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_TaxAmt2 === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_TaxAmt2}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.AddCess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Add Cess"
            xValue={bufferObj?.AddCess}
            xType={"text"} // text/number/password
            xName={"AddCess"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.AddCess === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.AddCess}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={vRdxCheckbox.AddCess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Add Cess Amt"
            xValue={bufferObj.B_NetAddCess}
            xType={"text"} // text/number/password
            xName={"B_NetAddCess"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_NetAddCess === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_NetAddCess}
            // xOnKeyUp={(e) => {
            //   xFocusInput("SplDiscPerc");
            // }}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={1}   className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="Total"
            xValue={bufferObj.B_LandVal}
            xType={"number"} // text/number/password
            xName={"B_LandVal"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_LandVal === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_LandVal}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={3}
          md={2}
          lg={2}
          className={
            vRdxCheckbox.Narration
              ? " lastkeyDetect dropDowntoggle"
              : "hide-content dropDowntoggle"
          }
        >
          
          <CmpInputFieldGroupV1
           xLabelText="Narration"               
            xtabIndex={"111"}
            xValue={bufferObj.Narration}
            xType={"text"} // text/number/password
            xName={"Narration"}
            xReadOnly={false}
            xOnChange={(e) => {
              fonChangeInputNarration(e.target.value);
            }}
            xOnKeyUp={fNarrationKeyEnter}
            xError={sErrorMsgDetail.Narration == "" ? true : false}
            xErrorMessage={sErrorMsgDetail.Narration}
            xTextAlign="start"
            xonFocus={""}
            xonBlur={""}
          />
          {xNarrationToggleDropdown ? (
            <div className="dropDowntoggleAbsolute">
              <GCToggleTableSearch
                xrows={xrowDropdownNarrationSearch}
                xcolumns={xcolumnsDropdownNarrationSearch}
                xRowCellClick={xOnCellKeyNarrationDown}
                xRowClick={xOnRowNarrationClick}
                xMediaQuery={xMediaQuery}
              />
            </div>
          ) : (
            <></>
          )}
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={2.2}
          lg={2.2}
          className={
            vRdxCheckbox.Incentive && DBKernObj("SONAS_INVOICE")
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpSelectFieldV1
            xtabIndex={"103"}
            xLabelText="IncentiveGroup"
            xValue={bufferObj.B_IncGroup}
            xOnChange={(e) => {
              fOnChangeSelectIncGroup(e, IncentiveGroups);
            }}
            xName={"B_IncGroup"}
            xData={IncentiveGroups}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_IncGroup === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_IncGroup}
            xDisable={false}
            // xOnKeyUp={""}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={
            vRdxCheckbox.Incentive && DBKernObj("SONAS_INVOICE")
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="Supervisor%"
            xValue={bufferObj.B_SuprvPerc}
            xType={"text"} // text/number/password
            xName={"B_SuprvPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_SuprvPerc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_SuprvPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={
            vRdxCheckbox.Incentive &&  DBKernObj("SONAS_INVOICE")
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
         <CmpTextFieldV1
            xLabelText="Others%"
            xValue={bufferObj.B_OthersPerc}
            xType={"text"} // text/number/password
            xName={"B_OthersPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_OthersPerc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_OthersPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={2}
          lg={2}
          className={
            vRdxCheckbox.Incentive && DBKernObj("SONAS_INVOICE")
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpSelectArrFieldV1
                     xtabIndex={"114"}
                     xLabelText="SupervisorSlab"
            xValue={bufferObj.B_SLANSuprv}
            xOnChange={(e) => {
              fOnChangeSelectSupervisorSlab(e, SupervisorSlabs);
            }}
            xName={"B_SLANSuprv"}
            xData={SupervisorSlabs}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_SLANSuprv === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_SLANSuprv}
            xDisable={false}
            // xOnKeyUp={""}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={
            vRdxCheckbox.Incentive && DBKernObj("SONAS_INVOICE")
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="Amt/Sc"
            xValue={bufferObj.B_SlabAmtSuprv}
            xType={"text"} // text/number/password
            xName={"B_SlabAmtSuprv"}
            xReadOnly={bufferObj.B_SLANSuprv !== "SC"}
            xOnChange={fonChangeInputSupervisorAmtSc}
            xError={sErrorMsgDetail.B_SlabAmtSuprv === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_SlabAmtSuprv}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={2}
          lg={2}
          className={
            vRdxCheckbox.Incentive && DBKernObj("SONAS_INVOICE")
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpSelectArrFieldV1
            xtabIndex={"115"}
            xLabelText="OtherSlab"
            xValue={bufferObj.B_SLANOther}
            xOnChange={(e) => {
              fOnChangeSelectOtherSlab(e, OtherSlabs);
            }}
            xName={"B_SLANOther"}
            xData={OtherSlabs}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_SLANOther === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_SLANOther}
            xDisable={false}
            // xOnKeyUp={""}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
           
          className={
            vRdxCheckbox.Incentive && DBKernObj("SONAS_INVOICE")
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
         <CmpTextFieldV1
            xLabelText="Amt/Sc"
            xtabIndex={"115"}
            xValue={bufferObj.B_SlabAmtOther}
            xType={"number"} // text/number/password
            xName={"B_SlabAmtOther"}
            xReadOnly={bufferObj.B_SLANOther !== "SC"}
            xOnChange={fonChangeInputOtherAmtSc}
            xError={sErrorMsgDetail.B_SlabAmtOther === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_SlabAmtOther}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.5}
          className="lastkeyDetect"
          display={"flex  "}
          alignItems={"center"}
          justifyContent={"space-around"}
        >
          

          <div>
            
            {xMediaQuery && (
               
               <CmpButtonKWithIcon
               xOnClick={(e) => { 
                fModalContentOpen(e, "checkboxModal");
              }}
               xDisabled={false}
               xIcon={<VisibilityIcon fontSize={"small"} />}
               xcolor="primary"
             />
            )}
          </div>
        </Grid>
      </Grid>

      <Modal
        open={sOpenContentModal}
        onClose={fModalContentClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className={
            sOpenModalName == "checkboxModal"
              ? "model-content-checkbox"
              : "model-content-Item-Search"
          }
        >
          <div>
            {sOpenModalName == "checkboxModal" ? (
              <>
                <GCTitleSticky
                  title={"Detail list"}
                  onClose={fModalContentClose}
                />

                <div className="container-fluid">
                  <div className="wms-label">
                    <div className="checkbox-mb">
                      <label className="form-label ">
                        <input
                          className="form-check-input "
                          type="checkbox"
                          name="AllChecked"
                          checked={sIsChecked}
                          onChange={(e) => {
                            fIsAllChecked(e);
                          }}
                        />{" "}
                        All
                      </label>
                    </div>
                    <>
                      {vModelCheckboxArr?.map((obj, index) => (
                        <div
                          className="checkbox-mb"
                          key={"Wmscheckbox" + index}
                        >
                          <label className="form-label">
                            <input
                              className="form-check-input "
                              type="checkbox"
                              name={obj.name}
                              checked={obj.rdxName}
                              onChange={(e) => {
                                fSetCheckBox(e);
                              }}
                            />{" "}
                            {obj.name}
                          </label>
                        </div>
                      ))}
                    </>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </Box>
      </Modal>
    </form>
  );
}
